/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
Buyapowa.Controllers.FriendSignposting = class FriendSignposting {
  constructor(el) {
    this._optionSelected = this._optionSelected.bind(this);
    this.updatePostPurchaseTrackingSubmitButton = this.updatePostPurchaseTrackingSubmitButton.bind(this);
    this._allPostPurchaseTrackingFieldsValid = this._allPostPurchaseTrackingFieldsValid.bind(this);
    this.updateWordOfMouthSubmitButton = this.updateWordOfMouthSubmitButton.bind(this);
    this.revealPostPurchaseTrackingForm = this.revealPostPurchaseTrackingForm.bind(this);
    this.revealWordOfMouthForm = this.revealWordOfMouthForm.bind(this);
    this.submitWordOfMouthReferral = this.submitWordOfMouthReferral.bind(this);
    this._wordOfMouthRequestSuccess = this._wordOfMouthRequestSuccess.bind(this);
    this._wordOfMouthRequestError = this._wordOfMouthRequestError.bind(this);
    this.submitPostPurchaseTrackingClaim = this.submitPostPurchaseTrackingClaim.bind(this);
    this._requestSuccess = this._requestSuccess.bind(this);
    this._requestFailed = this._requestFailed.bind(this);
    this.el = el;
    this.view = new Buyapowa.Views.FriendSignposting(this.el, this);

    this.view.onOptionSelected(this._optionSelected);
    this.view.onOptionLinks();
    this.view.onPostPurchaseTrackingSelected(this.revealPostPurchaseTrackingForm);
    this.view.onWordOfMouthSelected(this.revealWordOfMouthForm);

    this.view.onPostPurchaseTrackingKeyPressed(this.updatePostPurchaseTrackingSubmitButton);
    this.view.onWordOfMouthKeyPressed(this.updateWordOfMouthSubmitButton);

    this.view.onPostPurchaseTrackingSubmitClick(this.submitPostPurchaseTrackingClaim);
    this.view.onWordOfMouthSubmitClick(this.submitWordOfMouthReferral);
  }

  _optionSelected(index) {
    const result = [];
    for (let i = 0; i < 2; i++) {
      this.view.setOptionUnselected(i, i !== index);
      result.push(this.view.setOptionSelected(i, i === index));
    }
    return result;
  }

  updatePostPurchaseTrackingSubmitButton() {
    this.view.hidePostPurchaseTrackingErrorMessage();
    if (this._allPostPurchaseTrackingFieldsValid()) {
      this.view.enablePostPurchaseTrackingSubmit();
    } else {
      this.view.disablePostPurchaseTrackingSubmit();
    }
    return this.view.toggleTick();
  }

  _allPostPurchaseTrackingFieldsValid() {
    const fields = ['customField', 'postPurchaseTrackingEmail'];
    for (var i of Array.from(fields)) {
      if (!this.view[`${i}Valid`]()) { return false; }
    }
    return true;
  }

  updateWordOfMouthSubmitButton() {
    this.view.hideWordOfMouthErrorMessage();
    if (this.view.wordOfMouthValid()) {
      this.view.enableWordOfMouthSubmit();
    } else {
      this.view.disableWordOfMouthSubmit();
    }
    return this.view.toggleTick();
  }

  revealPostPurchaseTrackingForm() {
    this.view.showPostPurchaseTrackingForm();
    return this.view.hideWordOfMouthForm();
  }

  revealWordOfMouthForm() {
    this.view.showWordOfMouthForm();
    this.view.hidePostPurchaseTrackingForm();
    return this.view.disablePostPurchaseTrackingSubmit();
  }

  submitWordOfMouthReferral(event) {
    event.preventDefault();
    return $.ajax({
      type: "POST",
      url: this.view.getWordOfMouthUrl(),
      data: this.view.getWordOfMouthData(),
      dataType: 'json',
      success: data => {
        if (data.success) {
          return this._wordOfMouthRequestSuccess(data.url);
        } else {
          return this._wordOfMouthRequestError();
        }
      }
    });
  }

  _wordOfMouthRequestSuccess(url) {
    return window.open(url, "_parent");
  }

  _wordOfMouthRequestError() {
    return this.view.showWordOfMouthErrorMessage();
  }

  submitPostPurchaseTrackingClaim() {
    return $.ajax({
      method: 'post',
      url: this.view.getPostPurchaseTrackingUrl(),
      data: this.view.getPostPurchaseTrackingData()
    }).done(this._requestSuccess).fail(this._requestFailed);
  }

  _requestSuccess() {
    return this.view.redirectToFriendConfirmationPage();
  }

  _requestFailed() {
    return this.view.showPostPurchaseTrackingErrorMessage();
  }
};
